const analyticsEvents = {
  ERROR: 'countries_to_error',
  SUCCESS: 'countries_to_success',
};

export const countriesToConfig = {
  analyticsEvents,
};
